import { Component, Input, OnInit } from '@angular/core';
import { FullScreenViewerService } from 'src/app/services/full-screen-viewer.service';

@Component({
  selector: 'full-screen-video-player',
  templateUrl: './full-screen-video-player.component.html',
  styleUrls: ['./full-screen-video-player.component.scss'],
})
export class FullScreenVideoPlayerComponent implements OnInit {

  @Input() url: string;

  constructor(
    public fullScreenViewer: FullScreenViewerService,
  ) { }

  ngOnInit() {}

  isEnabled() {
  }

  cancel() {
    this.fullScreenViewer.videoPlayerEnabled = false;
  }
}
